<template>
  <div class="home">
    <div ref="carouselWrapper" class="home-header carousel-container">
      <el-carousel ref="carousel" :autoplay="false">
        <el-carousel-item v-for="(item, index) in backList" :key="index">
          <div class="header-box">
            <img class="header-img" :src="item.picture" alt="" @click="toDetail({id: item.id,type: '活动'})">
            <div class="show-tips special-tips" @click="toDetail({id: item.id,type: '活动'})">
              <div class="tips-con" v-if="nowWidth > 600">
                <div class="text">{{ $i18n.locale === 'en' ? item.english_describe : item.describe }}</div>
              </div>
              <div class="tips-con special-con" v-else>
                <div class="text special-text">{{ $i18n.locale === 'en' ? item.english_describe : item.describe }}</div>
                <div class="show-icon" v-if="showIcon(index)">
                  <i class="el-icon-arrow-down" v-if="!IconActive[index]" @click.stop="showAll(index)"></i>
                  <i class="el-icon-arrow-up" v-else @click.stop="showLittle(index)"></i>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="header-box" @click="toDetail(centerObj)" :style="'background-image: url(' + item.img + ');'">
            <div v-if="index === 0" class="show-tips">
              <div class="tips-con">
                <div>2024年7月19日，中国—金砖国家人工智能发展与合作中心启动仪式在中国信息通信研究院举行。</div>
              </div>
            </div>
          </div> -->
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="home-content">
    <div class="info top-length" style="margin-top: 30px;">
      <div class="info-header"></div>
      <div class="info-title"  :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'">
        {{home.CenterAchievements}}
        <div class="bot-bg">Central achievements</div>
      </div>
    </div>
    <div class="info-btn special-btn">
      <!-- <div class="btn" @click="result(1)" :class="resultShow === 1 ? 'info-active' : ''">{{home.ResearchReport}}</div>
      <span class="line"></span> -->
      <!-- <div class="btn" @click="result(1)" :class="resultShow === 1 ? 'info-active' : ''">{{home.whitepaper}}</div>
      <span class="line"></span>
      <div class="btn" @click="result(2)" :class="resultShow === 2 ? 'info-active' : ''">{{home.BlueBook}}</div>
      <span class="line"></span> -->
      <div class="btn info-active" @click="result(3)" :class="$i18n.locale=='zh' ? '' : 'bot-tit-en'"> {{home.EventsMeetings}}</div>
      <!-- <span class="line"></span>
      <div class="btn">{{home.standard}}</div> -->
    </div>
    <div class="info-more">
      <span @click="goResult">{{home.learnMore}} ></span>
    </div>
    <div class="cooperate">
      <div v-if="resultShow === 1" class="swiper3">
        <div v-loading="resultLoad" class="swiper-wrapper">
          <div class="swiper-slide cont-list" v-for="(item, index) in allList" :key="index">
              <div class="photo-box blank-box"><img :src="item.picture" alt="" /></div>
          </div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
        <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
      </div>
      <div v-loading="resultLoad" v-if="resultShow === 2" class="swiper4">
        <div class="swiper-wrapper">
          <div class="swiper-slide cont-list" v-for="(item, index) in blueList" :key="index">
              <div class="photo-box"><img :src="item.picture" alt="" /></div>
          </div>
        </div>
        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
        <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
      </div>
      <div v-if="resultShow === 3" class="file-box special-file">
        <!-- <div
          class="file-items"
          v-for="(item, index) in mockList6"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="file-title">{{ item.title }}</div>
          <div class="time">{{ item.news_date }}</div>
        </div> -->
        <div
          class="special-items"
          v-for="(item, index) in mockList6"
          :key="index"
        >
          <div class="photo" @click="toDetail(item)"><img :src="item.picture" alt=""></div>
          <div class="file-title" @click="toDetail(item)">{{ $i18n.locale === 'en' ? item.english_title : item.title }}</div>
          <div class="time" @click="toDetail(item)">{{ $i18n.locale === 'zh' ? item.news_date : formatDate(item.news_date) }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="home-content">
      <div class="info">
        <div class="info-header"></div>
        <div class="info-title">
          {{home.InformationExchange}}
          <div class="bot-bg">Information exchange</div>
        </div>
      </div>
      <div class="info-btn">
        <div class="btn" @click="infoShow = 1" :class="infoShow === 1 ? 'info-active' : ''">{{home.InternationalNews}}</div>
        <span class="line"></span>
        <div class="btn" @click="infoShow = 2" :class="infoShow === 2 ? 'info-active' : ''">{{home.GlobalTrends}}</div>
      </div>
      <div class="info-more special-more more-down">
        <span @click="goInfo">{{home.learnMore}} ></span>
      </div>
      <div class="info-content">
        <div class="info-left" v-if="$i18n.locale=='zh'">
          <img v-if="infoShow === 1" src="@/assets/img/info-left.png" alt="">
          <img v-else src="@/assets/img/info-right.png" alt="">
        </div>
        <div class="info-left" v-else>
          <img v-if="infoShow === 1" src="@/assets/img/info-left-en.jpg" alt="">
          <img v-else src="@/assets/img/info-right-en.jpg" alt="">
        </div>
        <div class="info-right" v-if="infoShow === 1">
          <div class="right-box" v-for="item in mockList7.slice(0, 8)" :key="item.id" @click="goInternate(item)">
            <div class="name">{{ item.title }}</div>
            <div class="date">{{ item.news_date }}</div>
          </div>
        </div>
        <div class="info-right" v-if="infoShow === 2">
          <div class="right-box" v-for="item in mockList8.slice(0, 8)" :key="item.id" @click="goDetail(item, 'industry')">
            <div class="name">{{ item.title }}</div>
            <div class="date">{{ item.news_date }}</div>
          </div>
        </div>
      </div>
    </div> -->
      <!-- <div class="cydj" style="height: 302px;">
        <div class="back-bg">
          <div style="height: 60px;"></div>
          <div class="info top-length" >
            <div class="info-header"></div>
            <div class="info-title">
              {{home.Industrydocking}}
              <div class="bot-bg">Industry docking</div>
            </div>
          </div>
          <div class="btns">
            <a href="javascript:;" @click="go"><img src="../assets/home/i1.png"/><span>{{home.SupplyApplication}}</span></a>
            <a href="javascript:;" @click="go"><img src="../assets/home/i2.png"/><span>{{home.RequestApplication}}</span></a>
          </div>
        </div>
      </div> -->

      <!-- <div class="info" style="margin-top: 60px;">
        <div class="info-header"></div>
        <div class="info-title">
          {{home.ApplicationEmpowerment}}
          <div class="bot-bg">Application Empowerment</div>
        </div>
      </div>

      <div class="info-btn">
        <div class="btn" @click="dealCon(2)" :class="conShow === 2 ? 'info-active' : ''">{{home.OverseasCases}}</div>
        <span class="line"></span>
        <div class="btn" @click="dealCon(1)" :class="conShow === 1 ? 'info-active' : ''">{{home.Partners}}</div>
      </div>
      <div class="info-more special-more more-down">
        <span @click="goDock">{{home.learnMore}} ></span>
      </div>
      <div v-show="conShow === 1">
        <div v-loading="dealLoad" class="swiper">
          <div class="swiper-wrapper">
            <div v-for="item in mockList2" :key="item.id" class="swiper-slide company-list">
              <div class="items">
                <div class="special-photo"><img :src="item.company_picture" alt=""></div>
                <div class="tips">{{ item.company_name }}</div>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
          <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
        </div>
      </div>
      <div v-show="conShow === 2">
        <div v-loading="dealLoad" class="swiper8">
          <div class="swiper-wrapper">
            <div class="swiper-slide cont-list cont-special" v-for="(item, index) in mockList1" :key="index" @click="open(item.case_pdf)">
              <div class="photo-box"><img :src="item.case_picture" alt="" /></div>
              <div class="title-box">
                {{ item.case_name }}
              </div>
            </div>
          </div>
          <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
          <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
        </div>
      </div> -->
      <!-- <div class="home-back">
        <div class="home-bg" :class="interactShow === 2 ? 'special-Show' : ''">
          <div class="info" style="padding-top: 70px;">
            <div class="info-header"></div>
            <div class="info-title">
              {{home.GovernanceCooperation}}
              <div class="bot-bg">Governance cooperation</div>
            </div>
          </div>
          <div class="info-btn special-btn">
            <div class="btn" @click="interact(3)" :class="interactShow === 3 ? 'info-active' : ''">{{home.ResearchReport}}</div>
            <span class="line"></span>
            <div class="btn" @click="interact(1)" :class="interactShow === 1 ? 'info-active' : ''">{{home.PoliciesAndRegulations}}</div>
            <span class="line"></span>
            <div class="btn" @click="interact(2)" :class="interactShow === 2 ? 'info-active' : ''">{{home.InternationalGovernance}}</div>
            <span class="line"></span>
            <div class="btn" @click="openWindow">{{home.InternationalStandards}}</div>
          </div>
          <div class="info-more" @click="goVernance">
            <span>{{home.learnMore}} ></span>
          </div>
          <div class="cooperate">
            <div v-if="interactShow === 1" class="file-box">
              <div
                class="file-items"
                v-for="(item, index) in mockList4.slice(0, 6)"
                :key="index"
                @click="goDetail(item, 'policy')"
              >
                <div class="file-title">{{ item.title }}</div>
                <div class="time">{{ item.news_date }}</div>
              </div>
            </div>
            <div v-if="interactShow === 3" class="file-box">
              <div
                class="file-items"
                v-for="(item, index) in jzwjAllList"
                :key="index"
                @click="jzwjHttp(item)"
              >
                <div class="file-title">{{ item.title }}</div>
                <div class="time">{{ item.data_date }}</div>
              </div>
            </div>
            <div v-if="interactShow === 2" class="swiper2">
              <div v-loading="interactLoad" class="swiper-wrapper">
                <div class="swiper-slide cont-list" v-for="(item, index) in mockList3" :key="index">
                  <div class="photo-box"><img :src="item.picture" alt="" /></div>
                  <div class="title-box">
                    {{ item.title }}
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev"><img src="@/assets/img/left.png" alt=""></div>
              <div class="swiper-button-next"><img src="@/assets/img/right.png" alt=""></div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="gywm" style="padding-bottom: 50px;">
        <div class="info" style="position: absolute;left: 0;right: 0;">
          <div class="info-header"></div>
          <div class="info-title">
            {{home.Aboutus}}
            <div class="bot-bg">About Us</div>
          </div>
        </div>
        <div class="imgBox" style="padding-top: 90px;">
          <img style="max-width: 1200px;" v-if="$i18n.locale=='zh'" src="../assets/home/my.jpg"/>
          <img style="max-width: 1200px;" v-else src="../assets/home/myen.jpg"/>
        </div>
      </div> -->
    </div>

  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import mock from "../../public/json/应用赋能-出海案例.json";
import mock2 from "../../public/json/应用赋能-合作公司.json";
import mock3 from "../../public/json/治理合作-国际治理.json";
import mock4 from "../../public/json/治理合作-政策法规.json";
import mock5 from "../../public/json/中心成果-白皮书蓝皮书.json";
import mock6 from "../../public/json/中心成果-会议活动.json";
import mock7 from "../../public/json/信息交流-国际资讯.json";
import mock8 from "../../public/json/信息交流-全球趋势.json";
import mock9 from "../../public/json/首页轮播图.json";
import jzwj from '../../public/json/治理合作-资料报告.json'
export default {
  name: 'HomePage',
  data() {
    return {
      show: 1,
      mockList1: [],
      mockList2: [],
      mockList3: [],
      mockList4: [],
      blankList: [],
      allList: [],
      blueList: [],
      mockList6: [],
      mockList7: [],
      mockList8: [],
      infoShow: 1,
      conShow: 2,
      jzwjAllList: [],
      interactShow: 3,
      resultShow: 3,
      dealLoad: true,
      resultLoad: true,
      interactLoad: true,
      backList: [{
        picture: require("@/assets/img/20250915-51.jpg"),
        describe: '6月20日，中国—金砖国家人工智能发展与合作中心承办的人工智能赋能化学安全与安保国际研修班结业仪式在上海市徐汇区圆满落下帷幕。',
        id: 51,
        sort: 1,
        url: ''
      },{
        picture: require("@/assets/img/20250915-69.jpg"),
        describe: '2025年7月27日，金砖AI中心企业委员会启航并召开建设研讨会暨人工智能智库网络主题沙龙。',
        id: 69,
        sort: 2,
        url: ''
      },{
        picture: require("@/assets/img/20250915-71.jpg"),
        describe: '7月28日，埃塞俄比亚人工智能局长沃库、秘鲁国会主席首席顾问梅萨、德国使馆代表齐烁等一行人参访了金砖AI中心运营基地。',
        id: 71,
        sort: 3,
        url: ''
      },{
        picture: require("@/assets/img/20250915-52.jpg"),
        describe: '2025年6月20日，金砖AI中心助力人工智能国际培训合作，禁化武组织首届人工智能赋能化学安全与安保国际研修班圆满收官。',
        id: 52,
        sort: 4,
        url: ''
      },{
        picture: require("@/assets/img/20250915-47.jpg"),
        describe: '2025年5月20日，中国—金砖国家人工智能发展与合作中心承办的“智汇金砖 AI创未来”金砖国家人工智能高级别论坛在巴西利亚圆满落幕。',
        id: 47,
        sort: 5,
        url: ''
      }],
      lineList: [],
      IconActive: [],
    }
  },
  computed:{
    home(){
      return this.$t('home')
    },
    nowWidth() {
      return window.innerWidth;
    }
  },
  watch: {
    '$i18n.locale'() {
      this.Loading = true
      setTimeout(() => {
        this.getLineRow()
      })
    }
  },
  mounted() {
    this.mockList1 = mock["RECORDS"];
    this.mockList2 = mock2["RECORDS"];
    this.mockList3 = mock3["RECORDS"].slice(0, 6);
    this.mockList4 = mock4["RECORDS"];
    this.mockList6 = mock6["RECORDS"].filter(item => item.picture).sort((a, b) => {return b.news_date.split('-').join('') - a.news_date.split('-').join('')}).slice(0, 12);
    this.mockList7 = mock7["RECORDS"];
    this.mockList8 = mock8["RECORDS"];
    this.backList = mock9["RECORDS"].sort((a, b) => {return a.sort - b.sort});
    this.blankList = mock5.RECORDS.filter( (item) => item.type == '白皮书').slice(0, 4);
    this.blueList = mock5.RECORDS.filter( (item) => item.type == '蓝皮书').slice(0, 4);
    this.allList = this.blankList.concat(this.blueList)
    this.jzwjAllList = jzwj.RECORDS.filter( (item) => item.type == '金砖中心ICT文件');
    this.updateCarouselHeight(); // 初始化时调整高度
    // window.addEventListener('resize', this.updateCarouselHeight);
    setTimeout(() => {
      this.delLoop()
    }, 3000)
    setTimeout(() => {
      this.getLineRow()
    })
    // this.delLoop()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCarouselHeight); // 清理事件监听器
  },
  methods: {
    updateCarouselHeight() {
      // 获取外部容器的高度
      // const wrapper = window.innerWidth;
      // console.log(wrapper, 'wrapper')

      // if (wrapper) {
      //   // 5088 × 3392
      //   const newHeight = wrapper / 1200 * 800; // 比如设置成宽度的 16:9 高度
      //   const carousel = this.$refs.carousel;
      //   if (carousel) {
      //     carousel.$el.style.height = `${newHeight}px`; // 动态设置 carousel 的高度
      //   }
      // }
    },
    go () {
      this.$router.push('applicationProcess')
    },
    showAll(index) {
      const divElement = document.getElementsByClassName('special-text');
      divElement[index].style.display = 'block'
      this.$set(this.IconActive, index, true)
      const divtips = document.getElementsByClassName('special-tips');
      // divtips[index].style.height = '300 !important'
      divtips[0].className = divtips[0].className + ' new-tips'
      // divCon[index].style.height = 'auto !important'
    },
    showLittle(index) {
      const divElement = document.getElementsByClassName('special-text');
      divElement[index].style.display = '-webkit-box'
      this.$set(this.IconActive, index, false)
      const divtips = document.getElementsByClassName('special-tips');
      // divtips[index].style.height = '300 !important'
      divtips[0].className = 'show-tips special-tips'
      // divCon[index].style.height = 'auto !important'
    },
    showIcon(index) {
      return this.lineList[index]
    },
    async getLineRow() {
      this.lineList = []
      this.IconActive = []
      const divElement = document.getElementsByClassName('special-text');
      for(let i = 0; i < divElement.length; i++) {
        this.lineList.push(await this.getTextLineCount(divElement[i]))
        this.IconActive.push(false)
        // if (divElement[i].style.display !== 'block') {
        //   this.IconActive.push(false)
        // } else {
        //   this.IconActive.push(true)
        // }
      }
      // divElement.forEach((element) => {
      //   // this.getTextLineCount(element)
      //   this.lineList.push(this.getTextLineCount(element))
      // })
    },
    toDetail(item){
      const query = {
        id: item.id,
        type: item.type,
      }
      this.$router.push({ path: '/activeDetail', query })
    },
    getTextLineCount(element) {
      // 获取元素的总高度
      // const totalHeight = element.offsetHeight;
      return new Promise((resolve) => {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
          const visibleHeight = rect.height;
          // console.log(totalHeight, window.getComputedStyle(element).lineHeight, 'totalHeight');

          // 获取元素的行高（使用 line-height，如果没有设置，默认为 font-size）
          const totalHeight = element.scrollHeight;
          // 计算并返回占用的行数
          resolve(visibleHeight < totalHeight ? true : false);
        }, 200)
      });
    },
    delLoop() {
      this.dealswiper()
      this.dealswiper2()
      this.dealswiper3()
      this.dealswiper4()
      this.dealswiper8()
    },
    dealswiper() {
      new Swiper(".swiper", {
        // direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 4000, // 自动轮播时间间隔（单位：毫秒）
          disableOnInteraction: false, // 用户操作后是否禁用自动轮播
        },
        loop: true, // 循环模式选项
        // 如果需要前进后退按钮
        slidesPerView: 4,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      this.dealLoad = false
    },
    dealswiper2() {
      new Swiper(".swiper2", {
        // direction: "vertical", // 垂直切换选项
        loop: false, // 循环模式选项
        slidesPerView: 4,
        spaceBetween: 12,
        slidesPerGroup: 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      this.interactLoad = false
    },
    dealswiper3() {
      new Swiper(".swiper3", {
        // direction: "vertical", // 垂直切换选项
        loop: false, // 循环模式选项
        slidesPerView: 4,
        spaceBetween: 12,
        slidesPerGroup: 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      this.resultLoad = false
    },
    dealswiper4() {
      new Swiper(".swiper4", {
        // direction: "vertical", // 垂直切换选项
        loop: false, // 循环模式选项
        slidesPerView: 4,
        spaceBetween: 12,
        slidesPerGroup: 1,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      this.resultLoad = false
    },
    dealswiper8() {
      new Swiper(".swiper8", {
        slidesPerView: 4,
        spaceBetween: 12,
        slidesPerGroup: 1,
        // direction: "vertical", // 垂直切换选项
        loop: false, // 循环模式选项
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
      this.dealLoad = false
    },
    goInfo() {
      this.$router.push('/Interformation')
    },
    goVernance() {
      this.$router.push('/governance')
    },
    goDock() {
      this.$router.push('/countryMe')
    },
    goInternate(item) {
      window.open(item.url)
    },
    open(url) {
      window.open(url)
    },
    goDetail(item, type) {
      const query = {
        id: item.id,
        type: type,
        tit1:'信息交流',
        tit2:'了解更多国内外人工智能信息'
      }
      this.$router.push({ path: '/InfoDetail', query })
    },
    dealCon(number) {
      this.conShow = number
      if (number === 1) {
        this.dealLoad = true
        setTimeout(() => {
          this.dealswiper()
        }, 1000)
      }
      if (number === 2) {
        this.dealLoad = true
        setTimeout(() => {
          this.dealswiper8()
        }, 1000)
      }
    },
    jzwjHttp(item) {
      if(item.url) {
        window.open(item.url);
      }
    },
    interact(number) {
      this.interactShow = number
      if (number === 3) {
        this.interactLoad = true
        setTimeout(() => {
          this.dealswiper2()
        }, 1000)
      }
      // if (number === 2) {
      //   this.dealswiper2()
      // }
    },
    result(number) {
      this.resultShow = number
      if (number === 1) {
        this.resultLoad = true
        setTimeout(() => {
          this.dealswiper3()
        }, 1000)
      }
      if (number === 2) {
        this.resultLoad = true
        setTimeout(() => {
          this.dealswiper4()
        }, 1000)
      }
    },
    goResult() {
      this.$router.push({ path: '/Centraloutcome', query: { isSelect: '会议' } })
    },
    openWindow() {
      window.open('https://www.itu.int/rec/T-REC/en')
    },
    formatDate(inputDate) {
      const date = new Date(inputDate);
      if (isNaN(date)) {
        console.error('Invalid date format');
        return null;
      }
      const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ];
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    }
  }
}
</script>
<style scoped lang="scss">
.bot-tit-en {
  font-weight: 600 !important;
}
.gywm{
  background: #fff;
  .imgBox{
    img{
      width: 100%;
      max-width: 1200px;
    }
  }
}
.cydj{
  // background: url(../assets/home/bj.jpg) no-repeat;
  // background-size: 1700px 100%;
  // display: flex;
  // flex-direction: column;
  .back-bg {
    margin: 0 auto;
    max-width: 1200px;
    height: 312px;
    background: #F5F7FA;
    // background: url(../assets/home/bj.jpg) no-repeat;
    // background-size: 100% 100%;
    display: flex;
    flex-direction: column;
  }
  .btns{
    max-width: 1200px;
    margin: 0 auto;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    a{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 90px;
      background: url(../assets/home/btn.jpg) no-repeat;
      background-size: 100% 100%;
      font-size: 22px;
      color: #fff;
      text-decoration: none;
      padding: 0 30px;
      img{
        width: 40px;
        margin-left: 6px;
        margin-right: 20px;
      }
      span {
        display: inline-block;
        width: 200px;
      }
    }
    a:first-child{
      margin-right: 50px;
    }
  }
}
.home {
  // background: #F5F7FA;

}
.home-header {
  height: auto;
  width: 1200px;
  margin: 0 auto;
  // background: #000;
  ::v-deep .el-carousel__arrow {
    display: none !important;
  }
  ::v-deep .el-carousel__container {
    // height: 797px;
    // height: 100%;
    height: 700px;
  }
  .header-box {
    width: 100%;
    height: 100%;
    // background-color: #dfe5f9;
    // width: 1200px;
    // margin: 0 auto;
    // height: 797px;
    // padding: 205px 0 174px;
    position: absolute;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: contain;
    // background-size: 100% 100%;
    // background-size: cover;
    // position: relative;
    cursor: pointer;
    img {
      position: absolute;
      left: calc(50% - 600px);
      // height: 798px;
      width: 1200px;
      // position: absolute;
      // top: -50px;
      // left: 0px;
    }
    .show-tips {
      width: 1200px;
      background: rgba(0, 0, 0, 0.5);
      height: 120px;
      position: absolute;
      left: calc(50% - 600px);
      bottom: 0px;
      display: flex;
      align-items: center;
      .tips-con {
        width: 1200px;
        height: 100px;
        margin: 0 auto;
        color: #fff;
        font-size: 22px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .text {
          width: 94%;
          margin: 0px auto;
          text-align: left;
          &:first-child {
            font-weight: 600;
          }
        }
      }
    }
  }
  .header-title1 {
    width: 1180px;
    height: 150px;
    font-family: Inter;
    font-weight: 900;
    font-size: 50px;
    color: #FFFFFF;
    line-height: 75px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 0 auto;
  }
  .header-title2 {
    width: 1053px;
    height: 72px;
    font-family: Inter;
    font-weight: 500;
    font-size: 18px;
    color: #CCCCCC;
    line-height: 36px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 24px auto 0;
  }
  .title-more {
    margin: 109px auto 0;
    width: 192px;
    height: 64px;
    // background: #1B3E92;
    border-radius: 0px 0px 0px 0px;
    font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 22px;
    color: #FFFFFF;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: center;
    // cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      margin-left: 16px;
    }
  }
}
.home-content {
  padding: 100px 0;
  .top-length {
    // margin-top: 156px;
  }
  padding-top: 60px;
  padding-bottom: 1px;
  .info {
    .info-header {
      width: 84px;
      height: 4px;
      background: linear-gradient( 270deg, #1D3E95 0%, #4840C2 100%);
      border-radius: 4px 4px 4px 4px;
      margin: 0 auto 22px;
    }
    .info-title {
      margin: 0 auto;
      margin-top: 22px;
      height: 40px;
      font-family: Inter;
      font-weight: 400;
      font-size: 36px;
      color: #080808;
      line-height: 40px;
      position: relative;
      .bot-bg {
        height: 50px;
        font-family: Inter;
        font-weight: 700;
        font-size: 36px;
        color: rgba(194, 194, 194, 0.12);
        line-height: 50px;
        text-align: center;
        position: absolute;
        top: 5px;
        left: 50%;
        transform: translate(-50%, 0);
        white-space: nowrap;
      }
    }
  }
  .info-btn {
    display: flex;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    .btn {
      margin: 0 32px;
      height: 56px;
      border-radius: 0px 0px 0px 0px;
      font-family: Inter;
      font-weight: 400;
      font-size: 16px;
      color: #333640;
      line-height: 56px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      &:first-child {
        margin-left: 0px;
      }
    }
    .line {
      width: 1px;
      height: 24px;
      background: #CCCCCC;
      border-radius: 0px 0px 0px 0px;
    }
    .info-active {
      border-bottom: 1px solid #1B3E92;
    }
  }
  .special-btn {
    margin-top: 30px;
  }
  .info-more {
    max-width: 1200px;
    margin: -16px auto 0;
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    color: #61656C;
    line-height: 16px;
    font-style: normal;
    text-transform: none;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 30px;
    &>span {
      cursor: pointer;
    }
    &:hover {
      color: #1B3E92;
    }
  }
  .special-more {
    // max-width: 1200px;
  }
  .info-content {
    max-width: 1200px;
    margin: 0 auto;
    // padding: 0 2vw;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    .info-left {
      width: 50%;
      img {
        height: 600px;
        width: 100%;
      }
    }
    .info-right {
      width: 50%;
      margin-left: 30px;
      .right-box {
        width: 100%;
        padding-bottom: 32px;
        border-bottom: 1px solid #D8D8D8;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        cursor: pointer;
        .name {
          font-family: Inter;
          font-weight: 400;
          font-size: 18px;
          color: #333640;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          white-space:nowrap;
          overflow:hidden;
          text-overflow:ellipsis;
          margin-right: 60px;
        }
        .date {
          // height: 28px;
          font-family: D-DIN, D-DIN;
          font-weight: 400;
          font-size: 16px;
          color: #61656C;
          // line-height: 28px;
          text-align: right;
          font-style: normal;
          text-transform: none;
          min-width: 100px;
          white-space: nowrap;
        }
      }
      .right-box:hover {
        .name {
          color: #1B3E92;
        }
        .date {
          color: #1B3E92;
        }
      }
    }
  }
  .app-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 26px;
    .btn {
      padding: 0 20px;
      height: 78px;
      border-radius: 0px 0px 0px 0px;
      border: 1px solid #E6E6E6;
      font-family: Inter;
      font-weight: 400;
      font-size: 28px;
      color: #666666;
      line-height: 78px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
    }
    .active {
      background: #1B3E92;
      border-radius: 0px 0px 0px 0px;
      color: #FFFFFF;
    }
  }
  .cooperate {
    max-width: 1200px;
    margin: 0 auto;
    margin-top: 42px;
    ::v-deep .el-carousel__arrow {
      width: 60px;
      height: 60px;
    }
    ::v-deep .el-carousel__item {
      background-color: transparent;
    }
    .el-carousel {
      background-color: transparent;
    }
    .cont-list {
      display: flex;
      flex-wrap: wrap;
      margin: 2px 0;
      .items {
        width: calc(25% - 18px);
        height: auto;
        margin-right: 24px;
        box-shadow: 0px 4px 20px 5px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        &:nth-child(4n) {
          margin-right: 0px;
        }
        img {
          width: 100%;
          height: auto;
        }
        .title-box {
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border-top: 1px solid #d8d8d8;
          box-sizing: border-box;
        }
      }
    }
  }
}

.swiper{
  max-width: 1200px;
  margin: 0 auto;
  // height: 324px;
  height: 360px;
  overflow: hidden;
  position: relative;
  .swiper-button-prev {
    width: 60px;
    height: 60px;
    font-size: 24px;
    background: rgba(8,8,8,0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: '';
    }
  }
  .swiper-button-next {
    width: 60px;
    height: 60px;
    background: rgba(8,8,8,0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: '';
    }
  }
  .swiper-slide {
    text-align: center;
    // background-color: aqua;
  }
}
.swiper3,.swiper4{
  height: 500px;
}
.company-list {
  width: calc(330px - 25px) !important;
  height: auto;
  margin-right: 24px;
  display: flex;
  align-items: center;
  .items {
    width: 100%;
    background: #fff;
    // box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
    display: flex;
    flex-direction: column;
    .special-photo {
      border: 1px solid #eee;
      box-sizing: border-box;
      height: 305px;
      display: flex;
      align-items: center;
      background: #f9f9f9;
    }
    img {
      width: 100%;
      // border: 1px solid #eee;
      // height: 260px;
    }
    .tips {
      height: 62px;
      line-height: 62px;
      background: #fff;
      font-family: Inter;
      font-weight: 700;
      font-size: 16px;
      color: #333640;
      text-align: left;
      font-style: normal;
      text-transform: none;
      padding-left: 20px;
      border-top: 1px solid #ccc;
      // box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1);
    }
    &:hover {
      margin-bottom: 10px;
    }
  }
}
.home-back {
  .home-bg {
    max-width: 1200px;
    height: 780px;
    margin: 0 auto;
    // background: url(../assets/img/home-background.png) no-repeat;
    // background-size: 100% 100%;
  }
  // background: url(../assets/img/home-background.png) no-repeat;
  // background-size: 100% 100%;
}
.swiper8,.swiper2,.swiper3,.swiper4{
  max-width: 1200px;
  margin: 0 auto;
  height: 600px;
  overflow: hidden;
  position: relative;
  .swiper-button-prev {
    width: 60px;
    height: 60px;
    font-size: 24px;
    background: rgba(8,8,8,0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: '';
    }
  }
  .swiper-button-next {
    width: 60px;
    height: 60px;
    background: rgba(8,8,8,0.7);
    border-radius: 50%;
    color: #fff;
    img {
      width: 25px;
      height: 25px;
    }
    &::after {
      content: '';
    }
  }
  .swiper-slide {
    text-align: center;
  }
  .cont-list {
    display: flex;
    flex-wrap: wrap;
    margin: 2px 0;
    width: 300px;
    &:nth-child(4n) {
      margin-right: 0px;
    }
    .photo-box {
      height: 500px;
    }
    img {
      width: 100%;
      height: auto;
    }
    .title-box {
      box-sizing: border-box;
      height: 64px;
      padding: 5px 5px;
      width: 100%;
    }
    .blank-box {
      img {
        border: 1px solid #ccc;
        box-sizing: border-box;
      }
    }
  }
}
.file-box {
  margin-bottom: 40px;
  height: 470px;
  box-sizing: border-box;
  padding: 0 40px;
  // background: #FFFFFF;
  // box-shadow: 0px 4px 20px 5px rgba(0,0,0,0.1);
  border-radius: 0px 0px 0px 0px;
  overflow: hidden;
  .file-items {
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #d8d8d8;
    box-sizing: border-box;
    cursor: pointer;
    .time {
      font-size: 16px;
      color: #61656c;
      font-weight: 400;
      min-width: 100px;
      text-align: right;
    }
    &:last-child {
      border-bottom: 0px solid #d8d8d8;
    }
  }
}
// .special-file {
//   height: 245px;
// }
.special-file {
  display: flex;
  // align-items: center;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px;
  height: 100%;
  .special-items {
    // height: 340px;
    width: 290px;
    margin-bottom: 10px;
    // width: calc(25% - 20px);
    // padding: 0 10px;
    .photo {
      width: 100%;
      height: 240px;
      padding-bottom: 8px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .file-title {
      // display: -webkit-box;
      // -webkit-line-clamp: 2; //显示最大行数
      // -webkit-box-orient: vertical;
      // overflow: hidden;
      // text-overflow: ellipsis;
      text-align: left;
      font-size: 16px;
      line-height: 22px;
      color: #333333;
      cursor: pointer;
    }
    .time {
      padding-top: 8px;
      text-align: left;
      font-size: 16px;
      color: #666666;
      cursor: pointer;
    }
  }
}
.cont-special {
  .photo-box {
    height: 520px !important;
    border: 1px solid #eee;
    box-sizing: border-box;
  }
}
.swiper2,.swiper3,.swiper4 {
  height: 500px;
  .cont-list {
    display: flex;
    flex-wrap: wrap;
    margin: 2px 0;
    width: 300px;
    &:nth-child(4n) {
      margin-right: 0px;
    }
    .photo-box {
      height: 420px;
    }
    img {
      width: 100%;
      height: auto;
    }
    .title-box {
      box-sizing: border-box;
      height: 64px;
      padding: 5 5px;
      width: 100%;
    }
  }
}
.swiper2 {
  .photo-box {
    // border: 1px solid #eee;
    // height: 412px !important;
    img {
      border: 1px solid #eee;
    }
  }
}
.swiper3,.swiper4 {
  display: flex;
  flex-direction: column;
  height: 420px;
  .photo-box {
    height: 410px;
    background: #fff;
  }
  .title-box {
    box-sizing: border-box;
    height: 64px;
    padding: 5 5px;
    width: 100%;
    background: #fff;
  }
}
@media (min-width: 1040px) {
  .home-header {
    width: 100%;
    // min-width: 1200px;
  }
}
@media (min-width: 600px) and (max-width: 1040px) {
  .home-header {
    width: 100%;
    // min-width: 1200px;
    .header-box {
      .show-tips {
        width: 100% !important;
        background: rgba(0, 0, 0, 0.5);
        height: 100px !important;
        position: absolute;
        // left: calc(100%);
        left: 0px !important;
        bottom: 0px;
        .tips-con {
          width: 100% !important;
          height: 80px;
          margin: 0 auto;
          color: #fff;
          font-size: 14px !important;
          display: flex;
          flex-direction: row;
          align-items: center;
          .text {
            width: 94%;
            margin: 0px auto;
            text-align: left;
            display: -webkit-box;
            // -webkit-line-clamp: 5; //显示最大行数
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            &:first-child {
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 600px) {
  .home-content {
    padding: 25px 0 !important;
    .top-length {
      margin-top: 10px;
    }
    .info-more {
      margin: 8px auto 8px;
    }
  }
  .home-header {
    // max-width: 600px !important;
    // height: auto;
    width: 100%;
  }
  ::v-deep .el-carousel__container {
    height: 237px !important;
    // width: 600px !important;
  }
  .header-box {
    img {
      // width: auto !important;
      height: 237px;
      width: 100% !important;
      position: unset !important;
      // width: 600px !important;
      // left: calc(50% - 200px) !important;
      // top: -70px;
    }
    .show-tips {
      // width: auto !important;
      // display: none;
    }
    .show-tips {
      width: 100% !important;
      background: rgba(0, 0, 0, 0.5);
      height: 100px !important;
      position: absolute;
      // left: calc(100%);
      left: 0px !important;
      bottom: 0px;
      .tips-con {
        width: 100% !important;
        height: 80px;
        margin: 0 auto;
        color: #fff;
        font-size: 12px !important;
        line-height: 16px !important;
        display: flex;
        flex-direction: row;
        align-items: center;
        position: relative;
        .text {
          width: 94%;
          margin: 0px auto;
          text-align: left;
          display: -webkit-box;
          -webkit-line-clamp: 3; //显示最大行数
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          &:first-child {
            font-weight: 600;
          }
        }
        .show-icon {
          widows: 20px;
          height: 20px;
          position: absolute;
          right: 1%;
        }
      }
    }
    .new-tips {
      height: auto !important;
      padding: 20px 0;
      .tips-con {
        height: auto !important;
      }
    }
  }
  ::v-deep .el-carousel__button {
    width: 18px !important;
  }
  .swiper{
    margin: 0 auto;
    // height: 324px;
    height: 200px;
    overflow: hidden;
    position: relative;
    .swiper-button-prev {
      width: 40px;
      height: 40px;
      font-size: 24px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .swiper-button-next {
      width: 40px;
      height: 40px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .swiper-slide {
      text-align: center;
      // background-color: aqua;
    }
  }
  .company-list {
    width: calc(138px) !important;
    height: auto;
    margin-right: 24px;
    display: flex;
    align-items: center;
    .items {
      width: 100%;
      background: #fff;
      box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
      display: flex;
      flex-direction: column;
      .special-photo {
        height: 138px;
        display: flex;
        align-items: center;
        background: #f9f9f9;
      }
      img {
        width: 100%;
        // height: 260px;
      }
      .tips {
        height: 62px;
        line-height: 62px;
        background: #fff;
        font-family: Inter;
        font-weight: 700;
        font-size: 14px;
        color: #333640;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding-left: 8px;
        border-top: 1px solid #ccc;
        // box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.1);
      }
      &:hover {
        margin-bottom: 10px;
      }
    }
  }
  .swiper8,.swiper2,.swiper3,.swiper4{
    // width: 1200px;
    margin: 0 auto;
    height: 210px;
    overflow: hidden;
    position: relative;
    .swiper-button-prev {
      width: 40px;
      height: 40px;
      font-size: 24px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .swiper-button-next {
      width: 40px;
      height: 40px;
      background: rgba(8,8,8,0.7);
      border-radius: 50%;
      color: #fff;
      img {
        width: 25px;
        height: 25px;
      }
      &::after {
        content: '';
      }
    }
    .swiper-slide {
      text-align: center;
    }
    .cont-list {
      display: flex;
      flex-wrap: wrap;
      margin: 2px 0;
      // margin-right: 0px !important;
      width: 300px;
      &:nth-child(4n) {
        margin-right: 0px;
      }
      .photo-box {
        height: 169px !important;
      }
      img {
        width: 100%;
        height: auto;
      }
      .title-box {
        display: none !important;
        box-sizing: border-box;
        height: 31px;
        padding: 5 5px;
        width: 100%;
        font-size: 12px !important;
        display: -webkit-box;
        -webkit-line-clamp: 2; //显示最大行数
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .info-btn {
    .btn {
      margin: 0 10px !important;
      display: -webkit-box;
      -webkit-line-clamp: 1; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px !important;
    }
  }
  .file-box {
    margin-bottom: 40px;
    height: 430px;
    box-sizing: border-box;
    padding: 0 40px;
    background: #FFFFFF;
    box-shadow: 0px 4px 20px 5px rgba(0,0,0,0.1);
    border-radius: 0px 0px 0px 0px;
    overflow: hidden;
    .file-items {
      border-bottom: 0.5px solid #ccc !important;
      display: inherit !important;
      height: 56px !important;
      .file-title {
        // line-height: 40px !important;
        font-size: 16px !important;
        margin-top: 15px !important;
        margin-bottom: 6px !important;
        text-align: left !important;
        // width: 250px;
        display: -webkit-box;
        // -webkit-line-clamp: 1; //显示最大行数
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .swiper3,.swiper4{
    height: 140px;
  }
  .info-left {
    display: none;
  }
  .info-right {
    width: 100% !important;
    margin-left: 0 !important;
    padding: 0 40px;
    box-sizing: border-box;
    .name {
      margin-right: 0px !important;
    }
  }
  .btns{
    width: 100% !important;
    padding: 0px 1vw !important;
    box-sizing: border-box;
    a{
      flex: none !important;
      height: 54px !important;
      font-size: 16px !important;
      padding: 0 15px !important;
      img{
        height: 30px;
        width: auto !important;
        margin-right: 20px !important;
      }
      span {
        display: inline-block;
        width: 80px !important;
      }
    }
    a:first-child{
      margin-right: 10px !important;
    }
  }
  .bot-bg {
    font-size: 30px !important;
  }
  .gywm {
    position: relative;
    .info {
      top: 10px;
    }
  }
  .info-title {
    font-size: 28px !important;
  }
  .info-more {
    font-size: 14px !important;
    span {
      padding-right: 10px;
    }
  }
  .info-right {
    padding: 0 20px !important;
    // display: unset !important;
  }
  .file-box {
    padding: 0 20px !important;
  }
  .imgBox {
    padding: 0 2vw;
    pointer-events: none !important;
    img {
      width: 100% !important;
    }
  }
  .home-bg {
    height: 640px !important;
    .info {
      padding-top: 0 !important;
    }
    // height: 300px !important;
  }
  .special-Show {
    height: 330px !important;
  }
  .file-items {
    font-weight: 400 !important;
  }
  .date {
    margin-top: 2px !important;
    font-size: 14px !important;
  }
  .cooperate {
    margin-top: 20px !important;
  }
  .right-box {
    // display: unset !important;
    display: inherit !important;
    // height: 40px !important;
    padding-bottom: 8px !important;
    box-sizing: border-box;
    border-bottom: 0.5px solid #eee !important;
    .name {
      font-size: 16px !important;
    }
  }
  .more-down {
    height: 56px !important;
    margin-top: -56px !important;
  }
  .special-btn {
    margin-top: 10px !important;
  }
  .swiper2 {
    height: 140px !important;
    .photo-box {
      // border: 1px solid #eee;
      // height: 412px !important;
      height: 140px !important;
    }
  }
  .special-file {
  display: flex;
  // align-items: center;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px !important;
  height: 100%;
  .special-items {
    // height: 200px;
    width: 180px;
    // width: calc(25% - 20px);
    // padding: 0 10px;
    .photo {
      width: 100%;
      height: 150px;
      padding-bottom: 8px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .file-title {
      display: -webkit-box;
      // -webkit-line-clamp: 2; //显示最大行数
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: left;
      font-size: 14px;
      color: #333333;
      cursor: pointer;
    }
    .time {
      padding-top: 8px;
      text-align: left;
      font-size: 12px;
      color: #666666;
      cursor: pointer;
    }
  }
}
}
</style>
